import { helper } from '@ember/component/helper';
import {
  bySequence,
  type Sequenced,
} from '@linc-technologies/linced-common/utils/sorting';

// sort-by-sequence gives a sorted copy of the items: by sequence, then by
// label, with no sequence (0) last. See bySequence.
//
// Usage: {{#each (sort-by-sequence this.subjects) as |subject|}}
export default helper(function sortBySequence<T extends Sequenced>([items]: [
  Iterable<T> | null | undefined,
]): T[] {
  return Array.from(items ?? []).sort(bySequence);
});
